import { Center, Spinner, Text, VStack } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router-dom";
import { SourcingEventStatus, useGetSourcingEventQuery } from "../../../../autogen/bff-api";
import { useSub } from "../../../../common/subscription/useSub";
import { urls } from "../../../../urls";
import { EditSourcingEventWizardForm } from "./EditSourcingEventWizardForm";

export const EditSourcingEventWizard = () => {
  const params = useParams();
  const { t } = useTranslation();
  const sub = useSub();

  const { data: event, isLoading, isError, refetch } = useGetSourcingEventQuery(
    params.eventId ? { eventId: params.eventId } : skipToken
  );

  if (!params.eventId) return <div>{t("404 event not found")}</div>;

  if (isLoading) {
    return (
      <Center h="40vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (isError || !event) {
    return (
      <Center h="40vh">
        <VStack>
          <Text>{t("Could not load event")}</Text>
        </VStack>
      </Center>
    );
  }

  if (event.status !== SourcingEventStatus.Draft || !sub.canCreateEvents) {
    return <Navigate to={urls.v2.sourcingEvents.view.go(event.id)} replace />;
  }

  return <EditSourcingEventWizardForm key={event.id} eventId={event.id} event={event} refetch={refetch} />;
};
